import React from 'react';
import { isNil } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';
import CollaboratorPermission from '../../../utils/permissions';
import * as Molecules from '../../molecules';
import { actions } from '../../../store/actions/actions';
import { localI18n } from '../../../i18n';
const uxCopy = {
  members: localI18n._("members")
};
export default (() => {
  const dispatch = useDispatch();
  const {
    isOwner,
    organization,
    collaboratorOrganizationPermission
  } = useSelector(state => {
    var _state$unifiedPrivacy, _state$userPermission;
    return {
      organization: state.organization.value,
      isOwner: !!((_state$unifiedPrivacy = state.unifiedPrivacy.value) === null || _state$unifiedPrivacy === void 0 ? void 0 : _state$unifiedPrivacy.is_owner),
      collaboratorOrganizationPermission: (_state$userPermission = state.userPermissions.value) === null || _state$userPermission === void 0 ? void 0 : _state$userPermission.collaborator.organization
    };
  });
  const isOrgSharingPossible = !isNil(organization === null || organization === void 0 ? void 0 : organization.organization_id);
  if (isOrgSharingPossible && !isNil(organization) && !isNil(collaboratorOrganizationPermission)) {
    const currentPermissionState = CollaboratorPermission.fromPermissionType(organization);
    const maybeAddPermissions = isOwner && isOrgSharingPossible ? CollaboratorPermission.fromAccessRight(collaboratorOrganizationPermission.add) : null;
    const permissionOptions = !isNil(maybeAddPermissions) ? maybeAddPermissions.permissionOptions() : !isNil(currentPermissionState) ? currentPermissionState.permissionOptions() : [];
    return React.createElement(Molecules.Dumb.OrgCollaborator, {
      teamName: organization.organization_name,
      caption: `${organization.organization_member_count} ${uxCopy.members}`,
      permission: currentPermissionState,
      onChange: permission => dispatch(actions.updateOrganization(permission)),
      onRemove: () => dispatch(actions.removeOrganization()),
      permissionOptions: permissionOptions,
      isDisabled: !isOwner
    });
  } else {
    return null;
  }
});